import dayjs from 'dayjs';

import { ISO_DATE_NO_TZ } from 'technical/time-utils/constants';

export function parseTaskDateString(dateString: string) {
  return dayjs(dateString).tz();
}

/**
 * Antd TimePicket doesn't do well with timezone but only for the Europe/London while being
 * in another timezone.
 *
 * It cause a display issue, in the input it can display 9:30 but if you click on it or submit
 * the form, the value will be 10:30
 *
 * To prevent this, we use the same trick as for shift-report date in shift-report/report/services/timeOperations.ts.
 * The date is parse, formated without the timezone offset and then re-parsed
 */
export function parseTaskDateStringWithoutTimezoneForAntdInput(
  dateString: string,
) {
  return dayjs(dayjs(dateString).tz().format(ISO_DATE_NO_TZ));
}

export function formatTaskDateStringToLocalizedTime(dateString: string) {
  return dayjs(dateString).tz().format('LT');
}
